import { Stack, styled } from '@mui/material';

export const IconBox = styled(Stack)`
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.common.white};
  border-radius: 4px;
  padding: 7px;
  width: fit-content;
`;

export const PlanWrapper = styled(Stack)`
  border: 1px solid ${({ theme }) => theme.palette.neutral.otherBorder};
  border-radius: 15px;
  padding: 1.5rem;
  width: 100%;
  min-height: 400px;
  flex-shrink: 0;

  & .MuiButton-root {
    margin-top: auto;
  }

  /* Mobile */
  @media (max-width: 600px) {
    padding: 1.25rem;
    min-height: 380px;
  }

  /* Tablet - when sidebar appears, make cards more compact */
  @media (min-width: 900px) and (max-width: 1199px) {
    padding: 1.25rem;
    min-height: 380px;
  }

  /* Large screens - 4 across, reduce font sizes */
  @media (min-width: 1200px) {
    padding: 1.25rem;
    min-height: 360px;

    & .MuiTypography-h6 {
      font-size: 1.1rem;
    }
  }
`;
